import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as PromotionService from './../services/promotionService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import {
    dataPromotionSuccess,
    changeStatusCodeSuccess,
    getAllCampaignSuccess,
    getBundlesByCampaignIdSuccess,
    getHistoryCodeSuccess,
    checkPromotionSuccess,
    setListBundlesSuccess,
    setBundlesDetails, 
    parseExcelSuccess,
    setListAutoFillSuccess,
    setAutoFillDetailSuccess,
    getAllCampaignFilterSuccess,
    importFileSuccess,
    updateStatusGroupSuccess
} from '../actions/promotionAction';
import history from '../helpers/history';
import { get } from 'lodash';
import Bundle from "../models/Bundle";
import AutoFill from "../models/AutoFill";
import { parseRatingListRequestParams } from "../utils/commonUtils";

function* getListPromotion() {
    yield takeLatest(Types.PROMOTION_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        const params = {
            ...action.filters,
            pageSize, pageIndex,
        };
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(PromotionService.getPromotions, params);
        yield put(dataPromotionSuccess(result));
    }, errorHandlePromotion(Types.PROMOTION_LIST_FAIL)))
}

function* changeStatusCode() {
    yield takeLatest(Types.PROMOTION_CHANGE_STATUS_CODE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(PromotionService.changeStatusCode, action);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.bundleName);
        yield put(changeStatusCodeSuccess(action.id, action.status));
        yield put({ type: Types.PROMOTION_LIST_ACTION, filters: action.filters })
    }, errorHandlePromotion(Types.PROMOTION_CHANGE_STATUS_CODE_FAIL)))
}

function* getAllCampaigns() {
    yield takeLatest(Types.PROMOTION_CAMPAIGN_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PromotionService.getAllCampaigns);
        yield put(getAllCampaignSuccess(result.data));
    }, errorHandlePromotion(Types.PROMOTION_CAMPAIGN_LIST_FAIL)))
}

function* getAllCampaignsFilter() {
    yield takeLatest(Types.PROMOTION_CAMPAIGN_LIST_FILTER_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PromotionService.getAllCampaignsFilter, action.filters);
        yield put(getAllCampaignFilterSuccess(result.data));
    }, errorHandlePromotion(Types.PROMOTION_CAMPAIGN_LIST_FILTER_FAIL)))
}

function* getBundlesByCampaign() {
    yield takeLatest(Types.BUNDLE_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PromotionService.getBundlesByCampaign, action.campaignId);
        yield put(getBundlesByCampaignIdSuccess(result.data));
    }, errorHandlePromotion(Types.BUNDLE_LIST_FAIL)))
}

function* exportExcel() {
    yield takeLatest(Types.PROMOTION_EXPORT_FILE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PromotionService.exportExcel, action.params);
        downloadFileExcel(result);
        successHandlePromotion(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.PROMOTION_EXPORT_FILE_SUCCESS });
    }, errorHandlePromotion(Types.PROMOTION_EXPORT_FILE_FAIL)))
}

function* getListHistoryCode() {
    yield takeLatest(Types.PROMOTION_GET_HISTORY_CODE_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        const params = {
            ...action.filters,
            pageSize, pageIndex,
        };
        const result = yield call(PromotionService.getHistoryCode, params);
        yield put(getHistoryCodeSuccess(result));
    }, errorHandlePromotion(Types.PROMOTION_LIST_FAIL)))
}

// Bundles
function* getListBundle() {
    yield takeLatest(Types.BUNDLES_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        const params = {
            ...action.filters,
            pageSize, pageIndex,
        };
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(PromotionService.getBundles, params);
        yield put(setListBundlesSuccess(result));
    }, errorHandlePromotion(Types.BUNDLES_LIST_FAIL)))
}

function* getBundleDetail() {
    yield takeLatest(Types.BUNDLES_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PromotionService.getBundleDetail, action.id);
        yield put(setBundlesDetails(result));
    }, errorHandlePromotion(Types.BUNDLES_DETAIL_FAIL)))
}

function* updateBundlesDetails(){
    yield takeLatest(Types.BUNDLES_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const newModel = new Bundle(action.bundle);
        yield call(PromotionService.updateBundlesDetails, newModel);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.updateSuccess')}`,
            description: `${i18n.t('item.autoFill.title')}`
        })
        yield put({ type: Types.BUNDLES_DETAIL_ACTION, id: newModel.id })
        history.push(PATHS.PROMOTION.LIST.path);
        history.go();
    }, errorHandlePromotion(Types.BUNDLES_DETAIL_FAIL)))
}

function* createBundleDetail() {
    yield takeLatest(Types.BUNDLES_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const bundle = new Bundle(action.bundle);
        const result = yield call(PromotionService.createBundleDetail, bundle);
        Func.sagaSuccessMessage({ action,
            message: `${i18n.t('notification.createSuccess')}`,
            description: `${i18n.t('item.page.title_page')} "${bundle.name}"`
        })
        history.push(PATHS.PROMOTION.LIST.path);
        history.go();
        yield put(setBundlesDetails(action.bundle));
    }, errorHandlePromotion(Types.BUNDLES_CREATE_FAIL)))
}

function* changeBundleStatus() {
    yield takeLatest(Types.BUNDLES_DEACTIVATED_CODE_ACTION, Func.sagaWrapper(function* (action) {
        const bundle = new Bundle(action.bundle)
        const result = yield call(PromotionService.bundlesChangeStatus, bundle);
        Func.sagaSuccessMessage({ action,
            message: `${i18n.t('notification.updateSuccess')}`
        });
        yield delay(SAGA_DELAY_TIMEOUT);
        const params = parseRatingListRequestParams(action.filter || {});
        const resultData = yield call(PromotionService.getBundles, params);
        yield put(setListBundlesSuccess(resultData));
    }, errorHandlePromotion(Types.BUNDLES_DEACTIVATED_CODE_FAIL)))
}

// AutoFill
function* getListAutoFill() {
    yield takeLatest(Types.AUTOFILL_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const pageSize = action.filters.pageSize ? action.filters.pageSize > 10 ? action.filters.pageSize : undefined : undefined;
        const pageIndex = action.filters.pageIndex ? action.filters.pageIndex > 1 ? action.filters.pageIndex : undefined : undefined;
        const params = {
            ...action.filters,
            pageSize, pageIndex,
        };
        const result = yield call(PromotionService.getAutoFills, params);
        yield put(setListAutoFillSuccess(result));
    }, errorHandlePromotion(Types.AUTOFILL_LIST_FAIL)))
}

function* createAutoFillCode() {
    yield takeLatest(Types.AUTOFILL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        const autoFill = new AutoFill(action.autoFill);
        const result = yield call(PromotionService.createAutoFill, autoFill);
        Func.sagaSuccessMessage({ action,
            message: `${i18n.t('notification.createSuccess')}`,
            description: `${i18n.t('item.page.title_page')}`
        })
        history.push(PATHS.AUTOFILL.LIST.path);
        history.go();
        yield put(setAutoFillDetailSuccess(action.autoFill));
    }, errorHandlePromotion(Types.AUTOFILL_CREATE_FAIL)))
}

function* getAutoFillDetailSaga() {
    yield takeLatest(Types.AUTOFILL_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PromotionService.getAutoFillDetail, action.id);
        yield put(setAutoFillDetailSuccess(result));
    }, errorHandlePromotion(Types.AUTOFILL_DETAIL_FAIL)))
}

function* updateAutoFillDetail() {
    yield takeLatest(Types.AUTOFILL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const newModel = new AutoFill(action.autoFill);
        yield call(PromotionService.updateAutoFill, newModel);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.updateSuccess')}`,
            description: `${i18n.t('item.autoFill.title')}`
        })
        yield put({ type: Types.AUTOFILL_DETAIL_ACTION, id: newModel.id })
        history.push(PATHS.AUTOFILL.LIST.path);
        history.go();
    }, errorHandlePromotion(Types.AUTOFILL_DETAIL_FAIL)))
}


function downloadFileExcel(result) {
    const fileName = result.headers['x-suggestion-filename'];
    const fileType = result.headers['content-type'];
    Func.downloadFile(result.data, 'promotion', { type: fileType });
}

function* checkPromotion() {
    yield takeLatest(Types.CHECK_PROMOTION_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PromotionService.checkPromotion, action.code);
        yield put(checkPromotionSuccess(result.data));
    }, errorHandlePromotion(Types.CHECK_PROMOTION_FAIL)))
}

function* fileStatusExcel() {
    yield takeLatest(Types.IMPORT_FILE_ACTION, Func.sagaWrapper(function* (action) {
        const formData = new FormData();
        formData.append('formFile', action.file);
        const result = yield call(PromotionService.fileStatusExcel, formData);
        yield put(importFileSuccess(result.data));
    }, errorHandlePromotion(Types.IMPORT_FILE_FAIL)))
}

function successHandlePromotion(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('item.promotions.title')} "${value}"`
    })
}

function* parseExcel() {
    yield takeLatest(Types.BUNDLES_PARSE_EXCEL_ACTION, Func.sagaWrapper(function* (action) {
        const formData = new FormData();
        formData.append('file', action.file);
        const result = yield call(PromotionService.parseExcel, formData);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.200'));
        yield put(parseExcelSuccess(result));
    }, errorHandlePromotion(Types.BUNDLES_PARSE_EXCEL_FAIL)))
}

function* bulkUpdatePromotionStatus() {
    yield takeLatest(Types.PROMOTION_BULK_UPDATE_STATUS_ACTION, Func.sagaWrapper(function* (action) {
        const data = action.params;
        yield call(PromotionService.bulkUpdatePromotionStatus, data);
        Func.sagaSuccessMessage({ action,
            message: `${i18n.t('notification.updateSuccess')}`
        });
        yield delay(SAGA_DELAY_TIMEOUT);
        const params = parseRatingListRequestParams(action.filters || {});
        const resultData = yield call(PromotionService.getPromotions, params);
        yield put(dataPromotionSuccess(resultData));
    }, errorHandlePromotion(Types.PROMOTION_BULK_UPDATE_STATUS_FAIL)))
}

function* updateStatusGroup() {
    yield takeLatest(Types.UPDATE_STATUS_GROUP_ACTION, Func.sagaWrapper(function* (action) {
        const resultData = yield call(PromotionService.updateStatusGroup, action.dataGroupCode);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'));
        yield put(updateStatusGroupSuccess(resultData));
        // const result = yield call(PromotionService.updateStatusGroup, action.dataStatusGroup);
    }, errorHandlePromotion(Types.UPDATE_STATUS_GROUP_FAIL)))
}

function* exportSampleExcel() {
    yield takeLatest(Types.GET_FILE_STATUS_SAMPLE_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(PromotionService.exportSampleExcel);
        downloadFileExcel(result);
        successHandlePromotion(action, `${i18n.t('notification.downloadSuccess')}`);
        yield put({ type: Types.GET_FILE_STATUS_SAMPLE_SUCCESS });
    }, errorHandlePromotion(Types.GET_FILE_STATUS_SAMPLE_FAIL)))
}

function errorHandlePromotion(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType, errors: get(e, 'data.errors[0]') })
    }, 'promotion');
}

export function* promotionSaga() {
    yield all([
        fork(getListPromotion),
        fork(changeStatusCode),
        fork(getAllCampaigns),
        fork(getAllCampaignsFilter),
        fork(getBundlesByCampaign),
        fork(exportExcel),
        fork(checkPromotion),
        fork(getListHistoryCode),
        fork(bulkUpdatePromotionStatus),
        // bundle
        fork(getListBundle),
        fork(createBundleDetail),
        fork(changeBundleStatus),
        fork(parseExcel),
        fork(getBundleDetail),
        fork(updateBundlesDetails),
        // autoFill
        fork(getListAutoFill),
        fork(createAutoFillCode),
        fork(getAutoFillDetailSaga),
        fork(updateAutoFillDetail),
        fork(fileStatusExcel),
        fork(updateStatusGroup),
        fork(exportSampleExcel)
    ])
}
